@if (erSvenskBankId()) {
  <div class="svensk">
    {{ 'Vennligst følg instruksjonene i sikkerhetsprogrammet'|translate }}
  </div>
}

<iframe data-testid="criiptodialog" #iframe></iframe>
